export const Suadi_fintech_URL = process.env.REACT_APP_BASE_URL;
// export const Suadi_fintech_URL = "https://int-fintech-backend.devbeans.io";
// export const Suadi_fintech_URL = "http://192.168.101.155:3000";
// export const Suadi_fintech_URL = "http://192.168.0.124:3000";
